import { render, staticRenderFns } from "./ModalChangeTable.vue?vue&type=template&id=1257fc09&scoped=true"
import script from "./ModalChangeTable.vue?vue&type=script&lang=js"
export * from "./ModalChangeTable.vue?vue&type=script&lang=js"
import style0 from "./ModalChangeTable.vue?vue&type=style&index=0&id=1257fc09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1257fc09",
  null
  
)

export default component.exports